import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';

/** Activity create or update request body */
export interface ActivityFormInterface {
  /** Activity name */
  name: string;
  /** Activity description */
  description?: string;
  /** Contragents */
  contragents?: ContragentFindInterface[];
}

/** Activity create or update request body - DTO schema */
export const ActivityFormDto = SerdeDtoClass.create<ActivityFormInterface>(ClientDtoKeysEnum.ACTIVITY_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  description: {
    label: 'Описание',
    optional: true,
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  contragents: {
    label: 'Контрагенты',
    optional: true,
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    })) as yup.Schema<any>,
  },
});
